module.exports = __webpack_public_path__ + "img/fig9.13.53e63e60.png";